import { render } from "./AboutView.vue?vue&type=template&id=185f3940"
const script = {}
script.render = render

export default script